module.exports = __webpack_public_path__ + "images/top-icon-return-s.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/top-icon-return-s.png
// module id = 875
// module chunks = 106